import { useCallback, useEffect, useState } from 'react'

export const useInactiveColumns = ({
	initialOpen = true,
	isDisabled = false,
	forceOpenSignal = 0,
} = {}) => {
	const [isOpen, setIsOpen] = useState(initialOpen)

	useEffect(() => {
		if (isDisabled) setIsOpen(false)
	}, [isDisabled])

	useEffect(() => {
		if (!isDisabled) setIsOpen(true)
	}, [forceOpenSignal, isDisabled])

	const toggleOpen = useCallback(() => {
		setIsOpen(v => !v)
	}, [])

	const onToggle = useCallback(() => {
		if (isDisabled) return
		toggleOpen()
	}, [isDisabled, toggleOpen])

	return { isOpen, onToggle, setIsOpen }
}
